<template>
  <v-card class="mx-auto ma-2" max-width="600">
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="headline">{{ this.$store.getters.competition.title }}</v-list-item-title>
        <v-list-item-subtitle>{{ this.$store.getters.competition.location }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-icon>
        <v-icon>mdi-calendar</v-icon>
      </v-list-item-icon>
      <v-list-item-subtitle>{{ this.$store.getters.competition.start | date }} - {{ this.$store.getters.competition.end | date }}</v-list-item-subtitle>
    </v-list-item>

    <v-divider></v-divider>

    <v-card-actions v-if="this.summary.applications">
      <v-btn text @click="printSummary">Print</v-btn>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" text @click="printResults">Print results</v-btn>
        </template>
        <span>Print results for races marked with Announcement</span>
      </v-tooltip>
    </v-card-actions>
  </v-card>
</template>

<script>
  import {
    VTooltip
  } from 'vuetify/lib'
    import fccapi from "../../fccapi";
  export default {
    name: 'FCCCompetitionDetails',
    props: {
      summary: Object,
      reload: Function
    },
    methods: {
        printSummary: function(){
            fccapi.competitionGet("summary-paper").then(d => {
                var docDefinition = d.data;
                var organizer = this.$store.getters['competition'].organizer;
                //docDefinition.watermark = { image: testImageDataUrl, width: 200 };//'/images/watermark.png' };
                docDefinition.footer = (currentPage, pageCount, pageSize) => {
                return [
                    {
                        //text: "Organizator tekmovanja je\nProstovoljno gasilsko društvo Radovljica, Gorenjska cesta 31, 4240 Radovljica",
                        text: "Competition organizer:\n"+organizer.longName+", "+organizer.address,
                        alignment: 'center',
                        margin: [20, -25, 20, 20]
                    }
                ]
                };
                var filename = this.$store.getters.competition.title + " summary.pdf";
                pdfMake.createPdf(docDefinition).download(filename);
            })
        },
        printResults: function(){
          fccapi.competitionGet("results2").then(d => {
              var docDefinition = d.data;
              //docDefinition.pageOrientation = 'landscape'

              var filename = this.$store.getters.competition.title + " results.pdf";
              pdfMake.createPdf(docDefinition).download(filename);
          })
        }
    },
    components: {
      VTooltip
    },
  }
</script>